@if (data) {
<div class="table-responsive gung-responsive">
  <table class="table">
    <thead>
      <tr>
        <th translate>STATUS</th>
        <th translate>ORDER_ID</th>
        <th translate>PRODUCT_ID</th>
        <th translate>DATE_CREATED</th>
        <th translate>CUSTOMER</th>
        <th *ngIf="!isUser" translate>ASSIGN_TO</th>
        <th translate>RMA_NR</th>
        <th style="min-width: 50px"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of data">

        <tr>
          <td [attr.data-label]="'STATUS' | translate" (click)="openViewModal(item)"
            class="cursor-pointer border-bottom-0">
            <span class="badge badge-pill badge badge-light d-block text-center m-0 p-2 w-100"
              [style.background-color]="claimStatusColor(item.status)">{{ item.status | translate }}</span>
          </td>

          <td class="border-bottom-0" [attr.data-label]="'ORDER_ID' | translate">
            {{ item.orderId }}
          </td>
          <td class="border-bottom-0" [attr.data-label]="'PRODUCT_ID' | translate">
            {{ item.extra.productId }}
          </td>
          <td class="border-bottom-0" [attr.data-label]="'DATE_CREATED' | translate">
            {{ item.date | date: dateUtilService.dateFormat }}
          </td>
          <td class="border-bottom-0" [attr.data-label]="'CUSTOMER' | translate">
            <b>{{ item.customerId }}</b>
            <br>{{ item.customerName }}
          </td>
          <td [attr.data-label]="'ASSIGN_TO' | translate" class="border-bottom-0">
            {{ item.extra.sendAttestTo }}
          </td>
            <td class="border-bottom-0" [attr.data-label]="'RMA_NR' | translate">
              {{ item.extra.rmaNr}}
            </td>
          
          <td [attr.data-label]="''" class="text-nowrap border-bottom-0">
            <button *ngIf="isAdmin && !customerView" type="button" class="btn btn-sm btn-outline-primary mr-2"
              (click)="openViewModal(item)">
              <i class="fas fa-edit"></i>
            </button>
            <button *ngIf="isAdmin && !customerView" type="button" class="btn btn-sm btn-danger mr-2"
              (click)="deleteOrderServices(item)">
              <i class="fas fa-trash"></i>
            </button>
            <button *ngIf="(isUser && !isAdmin) || customerView" type="button"
              class="btn btn-sm btn-outline-primary mr-2" (click)="openViewModal(item)">
              <i class="fa-solid fa-eye"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="item.comments?.length > 0 && item.comments[item.comments.length - 1].comment">
          <td></td>
          <td colspan="6" [attr.data-label]="'ERROR_DESCRIPTION' | translate" class="text-break">
            <span translate class="font-weight-bold">ERROR_DESCRIPTION</span>: {{ item.comments[item.comments.length - 1].comment }}
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
} @else {
<ng-template #loading>
  <i class="fa fa-spinner fa-spin fa-7x"></i>
  LOADING...
</ng-template>
}
